import React from "react";

import { HOME_DATA } from "../../../data/pages";

import { QualitiesList } from "../../design-system";

import * as styles from "./Qualities.module.scss";

const Qualities: React.FC = () => {
  return (
    <section className={styles.Qualities}>
      <div>
        <header className={styles.Qualities_header}>
          <h2 className={styles.Qualities_header_title}>
            The complete financial toolkit for your business
          </h2>
          <p>
            Powerful tools to manage money movement, track cash flow, and streamline operations. Built for modern businesses looking to work smarter, save time, and stay in control, all from one intuitive platform.
          </p>
        </header>

        <QualitiesList items={HOME_DATA.QUALITIES} />
      </div>
    </section>
  );
};

export default Qualities;
